import { IVisualizacaoPreviaGeracaoModalData } from './models/visualizacao-previa-geracao.modal.model';

export class VisualizacaoPreviaGeracaoModalController {
    static $inject = [
        '$uibModalInstance',
        'entity',
    ];

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public entity: IVisualizacaoPreviaGeracaoModalData,
    ) {}

    close() {
        this.$uibModalInstance.dismiss('fechar');
    }

    confirm() {
        this.$uibModalInstance.close(true);
    }
}
